function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 38.4778215,
  height: 39
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "PICA-\\u4E3B\\u7DE8\\u8F2F\\u9801",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u4E3B\\u7DE8\\u8F2F\\u9801-unfold-\\u4E0A\\u50B3",
  transform: "translate(-48.000000, -119.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Sidebar",
  transform: "translate(0.000000, 94.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u4E0A\\u50B3icon",
  transform: "translate(42.000000, 19.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "sidebar-\\u4E0A\\u50B3",
  transform: "translate(6.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5427909,24.7781081 L17.1855707,23.6444344 C18.591505,21.1647833 21.2598085,19.5 24.3158455,19.5 C28.1433572,19.5 31.3628208,22.1158634 32.2498751,25.6502896 L32.6888548,27.3993878 L34.4820834,27.672087 C36.4416406,27.9700802 37.9434073,29.6569887 37.9434073,31.6875 C37.9434073,33.9311573 36.1130277,35.75 33.8551388,35.75 L16.1393085,35.75 C13.1287905,35.75 10.6882838,33.3248756 10.6882838,30.3333333 C10.6882838,27.6440396 12.6632409,25.407903 15.2504432,24.9879041 L16.5427909,24.7781081 Z",
  id: "file-/-cloud_up",
  fill: "#E89A4F"
}), /*#__PURE__*/React.createElement("g", {
  id: "file-/-cloud_up"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "file-/-cloud_up-(Background/Mask)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.8259405,21.125 L19.2389108,14.625 L25.651881,21.125 L21.5636122,21.125 L21.5636122,26 L16.9142093,26 L16.9142093,21.125 L12.8259405,21.125 Z M19.2389108,6.5 C25.2485995,6.5 30.2929204,10.6893319 31.6842536,16.3439069 C35.5311789,16.940616 38.4778215,20.309024 38.4778215,24.375 C38.4778215,28.8623141 34.8888398,32.5 30.4616087,32.5 L9.61945538,32.5 C4.3067768,32.5 0,28.134776 0,22.75 C0,17.9045423 3.48727917,13.8846356 8.05675119,13.1280046 C10.2558835,9.17181391 14.4395571,6.5 19.2389108,6.5 C23.2453699,6.5 23.2453699,6.5 19.2389108,6.5 Z M8.57373154,16.3354849 L10.0941406,16.0837297 L10.8503522,14.7233213 C12.5043925,11.74774 15.6435731,9.75 19.2389108,9.75 C23.7418656,9.75 27.5294699,12.8890361 28.5730632,17.1303475 L29.0895099,19.2292653 L31.1991905,19.5565044 C33.504552,19.9140962 35.2713364,21.9383864 35.2713364,24.375 C35.2713364,27.0673888 33.1179486,29.25 30.4616087,29.25 L9.61945538,29.25 C6.07766953,29.25 3.20648513,26.3398507 3.20648513,22.75 C3.20648513,19.5228475 5.52996412,16.8394836 8.57373154,16.3354849 L8.57373154,16.3354849 Z",
  fill: "#FFFFFF",
  mask: "url(#mask-2)"
})))))));

function SvgTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "39px",
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sidebar-\u4E0A\u50B3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.102759c6.svg";
export { ForwardRef as ReactComponent };